const REGISTERED_PARAM = 'registriert'
const REGISTRATION_PATH = '/registrierung'

export function isRegistrationPath(pathname: string): boolean {
  return pathname === REGISTRATION_PATH || pathname === `${REGISTRATION_PATH}/`
}

export function takeRegistrationTokenFromUrl(): string | null {
  const url = new URL(window.location.href)
  if (!isRegistrationPath(url.pathname)) return null
  const fragment = new URLSearchParams(url.hash.slice(1))
  const token = fragment.get('token')
  if (fragment.has('token')) {
    fragment.delete('token')
    const rest = fragment.toString()
    window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${rest ? `#${rest}` : ''}`)
  }
  return token?.trim() || null
}

export function takeRegisteredFlagFromUrl(): boolean {
  const url = new URL(window.location.href)
  if (!url.searchParams.has(REGISTERED_PARAM)) return false
  const registered = url.searchParams.get(REGISTERED_PARAM) === '1'
  url.searchParams.delete(REGISTERED_PARAM)
  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`)
  return registered
}
